import type { FaireProductEntity } from "../../entity_types/product";

export const p_9s6qxhcgkt: FaireProductEntity = {
  token: "p_9s6qxhcgkt",
  type: "product",
  name: "Organic Holy Halvah NoirBar",
  brandToken: "b_psp4uwy7qx",
  brandName: "Holy Halvah",
  imageUrl:
    "https://cdn.faire.com/fastly/28b528d643e0ec0d694e777c7d6bd5c28235aa437a490e9050541d8da17ff123.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b731e5a5476f51b8c50c8178d1b8380bce65cb94d738967fc44865d4074d98bb.jpeg",
    "https://cdn.faire.com/fastly/8034a8b96b8ee9f501db5994796bc98d1285b4ecccd7602558a5580402fac900.jpeg",
    "https://cdn.faire.com/fastly/6a8ebe4c195426d8259b69c7391fb0d3c99fe3d9ab978e04c1c3bf8a2b550c67.jpeg",
    "https://cdn.faire.com/fastly/8d7e5c69eebd3103330248de9e9ab54905b0c1e0b20d28f348417ee5a5d3fa0f.jpeg",
    "https://cdn.faire.com/fastly/1d528af576c045ab692c4b00109d4664522494a8cfcb66b38d9620e0025796df.jpeg",
    "https://cdn.faire.com/fastly/b0262edc23f9b3c15b2c90110055bd1a468730bac8c2f7a97bd9bfbaaed8362e.png",
  ],
  priceDollars: 6.24,
  description:
    "Halvah is a simple, traditional sesame based snack. Our recipe uses just four real food ingredients: Organic sesame tahini, pure Vermont maple syrup, vanilla, and sea salt. That's it! This beautifully simple treat is an amazing energy source, and is free of gluten, grains, dairy, and refined sugar. \n\nThe Holy Halvah NoirBar re-imagines our original recipe with rich, black sesame tahini. You’ll find the texture silky and delicate with a nutty taste, reminiscent of roasted chestnuts.\nOur NoirBars are packaged in black mylar bags, and compliment the gold of the Original Bar when merchandised together. \n\nHoly Halvah is a super premium, organic, small batch, real food product\nWe choose to create this halvah without the use of additives or emulsifiers, and  it can be stored on the shelf for two weeks in a climate controlled environment (below 70F). Store for two months in a cooler, and up to a year in a freezer.",
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:29.506Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
